export default "/_next/static/chunks/fonts/TheinhardtLight-28dc4b88a47c0ea207d0a7d802bb8981.woff2";